import React, {useEffect, useState} from 'react';
//MUI
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
//Ds
import {toast} from 'lib.front';

function CodeWithButtonCopy(props) {
   const handleCopyToClipboard = text => {
      navigator.clipboard
         .writeText(text)
         .then(() => {
            toast.showSucces('Se copió correctamente ');
         })
         .catch(err => {
            console.error('No se pudo copiar el texto: ', err);
         });
   };
   return (
      <Grid container spacing={1}>
         <Grid item xs={10} style={{color: props.color, alignContent: 'center'}}>
            {props.info}
         </Grid>
         <Grid item xs={2} style={{alignContent: 'center'}}>
            <Tooltip title="Copiar código de activación">
               <IconButton onClick={() => handleCopyToClipboard(props.info)} size="large">
                  <FileCopyOutlinedIcon />
               </IconButton>
            </Tooltip>
         </Grid>
      </Grid>
   );
}

export default CodeWithButtonCopy;
